// extracted by mini-css-extract-plugin
export default {"notifyButton":"TalkUserListNotify_notifyButton__dlH6g"};